module.exports = __webpack_public_path__ + "static/media/menu-chat.bbde3366.svg";